module.exports = __webpack_public_path__ + "img/bsc_02.837d437b.png";